import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import Vue2Editor from 'vue2-editor';

Vue.use(Vuetify);
Vue.use(Vue2Editor);

export default new Vuetify({
});
